const GridLarge = (props) => {
    const { fill } = props
    return (
        <svg
            cursor="pointer"
            fill={fill}
            viewBox="0 0 64 64"
            data-testid="Grid__Large"
            color="green"
            {...props}
        >
            <title>Large Grid Density</title>
            <g transform="matrix(2.66667,0,0,2.66667,0,0)">
                <g transform="matrix(1.10706,0,0,0.832145,-1.29038,1.93007)">
                    <path d="M3,11L11,11L11,3L3,3M3,21L11,21L11,13L3,13M13,21L21,21L21,13L13,13M13,3L13,11L21,11L21,3" />
                </g>
            </g>
        </svg>
    )
}

export default GridLarge
